export const LFCONNECT_URLS = {
    sandbox: 'https://api.developers.lifefitness.com/partnerapi/staging',
    production: 'https://api.developers.lifefitness.com/partnerapi/production',
    sandbox_api: 'https://api.developers.lifefitness.com/partnerapi/staging/api/v3',
    production_api: 'https://api.developers.lifefitness.com/partnerapi/production/api/v3',
}



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/GettingStarted/Web/GettingStartedConstants.js